import { render, staticRenderFns } from "./Datatable2Select.vue?vue&type=template&id=6c7cac7e&scoped=true&"
import script from "./Datatable2Select.vue?vue&type=script&lang=js&"
export * from "./Datatable2Select.vue?vue&type=script&lang=js&"
import style0 from "./Datatable2Select.vue?vue&type=style&index=0&id=6c7cac7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7cac7e",
  null
  
)

export default component.exports